export default __webpack_public_path__ + "8fbff60c57769997a561d0aa43be7c42.svg";